export class ActitoProvider {
	protected goalId: string;
	protected goalUri: string;
	protected storeCode: string;

	constructor(actito: { goal_id: string; goal_uri: string }, storeCode: string) {
		this.goalId = actito.goal_id;
		this.goalUri = actito.goal_uri;
		this.storeCode = storeCode;
	}

	trackConversion(order: SalesOrder) {
		window._actGoal.settings = {
			value: this.goalUri,
			type: 'TRANSACTION',
			goalUrl: 'https://www.actito.be:443/actg',
			additionalParameters: [
				{ name: 'goalId', value: this.goalId },
				{ name: 'businessId', value: order.ref },
				{ name: 'amountCent', value: Math.round(order.grand_total * 100).toString() },
				{ name: 'source', value: '' },
				{ name: 'comment', value: this.storeCode },
			],
		};

		if (window._actGoal.process) {
			window._actGoal.process();
		}
	}
}

export default ActitoProvider;
